"use strict";

var _ = require("underscore");
var BaseModel = require("../../common/models/base-model");

var debug = require("debug")("models:TokenUserPrintModel");    //https://github.com/visionmedia/debug

/**
 * TokenUserPrintModel : récup d'un token d'impression en échange
 */
module.exports = BaseModel.extend({

    pv5api: null,

    defaults: {
        documentId: null,
        publicationId: null,
        pages: null,
        userPrintToken: null
    },

    /**
     * @param  {Object} attributes
     * @param  {Object} options
     * @param  {String} options.pv5api
     * @param  {String} options.token
     */
    initialize: function (attributes, options) {
        BaseModel.prototype.initialize.apply(this, arguments);
        debug("initialize");
        _.extend(this, options);
    },

    url: function () {
        var T = this;
        return T.pv5api + "/token-user-print";
    }

});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@immanens-com/pv5js/reader/models/token-user-print-model.js
// module id = 53
// module chunks = 0